import { createReducer, on } from '@ngrx/store';
import { IContractsState, initialContractsState } from './contracts.state';
import { ContractsLoaded } from './contracts.action';


export const initialState: IContractsState = {
  contracts: null
};

const setContracts = (state: IContractsState, { contracts }: { contracts: IContractsState['contracts'] }) => ({
  ...state,
  contracts: [ ...state.contracts, ...contracts ]
});


const _contractsReducer = createReducer<IContractsState>(
  initialContractsState,
  on(ContractsLoaded, setContracts)
);

export function contractsReducer(state: IContractsState, action): IContractsState {
  return _contractsReducer(state, action);
}
